// Dummy notifications data based on user role

export const getDummyNotifications = (role) => {
  switch (role) {
    case 'REGULATORY':
      return [
        {
          id: 1001,
          subject: "Impact Assessment Received",
          message: "John Smith has responded to your exit request for Sodium Benzoate (CAS: 532663).",
          read: false,
          createdAt: new Date().getTime() - 3600000, // 1 hour ago
          exitRequestId: 123, // Link to the exit request
          memberId: 101, // Link to the member who responded
          type: "RESPONSE_RECEIVED"
        },
        {
          id: 1002,
          subject: "Exit Plan Submitted",
          message: "Emma Davis has submitted an exit plan for Benzophenone-3 (CAS: 131577).",
          read: false,
          createdAt: new Date().getTime() - 24 * 3600000, // 1 day ago
          exitRequestId: 124,
          memberId: 102,
          type: "WAITING_FOR_APPROVALS"
        },
        {
          id: 1003,
          subject: "Request Deadline Approaching",
          message: "Exit request for Triclocarban (CAS: 101208) has 3 days until deadline.",
          read: true,
          createdAt: new Date().getTime() - 2 * 24 * 3600000, // 2 days ago
          exitRequestId: 125,
          type: "DEADLINE_APPROACHING"
        },
        {
          id: 1004,
          subject: "All Members Responded",
          message: "All R&D members have responded to your exit request for Phenoxyethanol (CAS: 122996).",
          read: true,
          createdAt: new Date().getTime() - 4 * 24 * 3600000, // 4 days ago
          exitRequestId: 126,
          type: "ALL_RESPONSES_RECEIVED"
        },
        {
          id: 1005,
          subject: "Exit Plan Updated",
          message: "Robert Johnson has updated the exit plan for Titanium Dioxide (CAS: 13463677).",
          read: false,
          createdAt: new Date().getTime() - 5 * 24 * 3600000, // 5 days ago
          exitRequestId: 127,
          memberId: 103,
          type: "EXIT_PLAN_UPDATED"
        }
      ];
    
    case 'R&D':
      return [
        {
          id: 2001,
          subject: "New Exit Request",
          message: "You have been assigned to evaluate Sodium Benzoate (CAS: 532663) for compliance.",
          read: false,
          createdAt: new Date().getTime() - 2 * 3600000, // 2 hours ago
          exitRequestId: 123,
          type: "NEW_ASSIGNMENT"
        },
        {
          id: 2002,
          subject: "Exit Request Deadline",
          message: "Exit request for Benzophenone-3 (CAS: 131577) is due tomorrow.",
          read: false,
          createdAt: new Date().getTime() - 12 * 3600000, // 12 hours ago
          exitRequestId: 124,
          type: "DEADLINE_TOMORROW"
        },
        {
          id: 2003,
          subject: "Exit Plan Feedback",
          message: "Your exit plan for Triclocarban (CAS: 101208) has been approved.",
          read: true,
          createdAt: new Date().getTime() - 3 * 24 * 3600000, // 3 days ago
          exitRequestId: 125,
          type: "EXIT_PLAN_APPROVED"
        }
      ];
      
    case 'ADMIN':
      return [
        {
          id: 3001,
          subject: "System Notification",
          message: "Weekly system maintenance scheduled for Saturday at 2:00 AM.",
          read: false,
          createdAt: new Date().getTime() - 8 * 3600000, // 8 hours ago
          type: "SYSTEM_MAINTENANCE"
        },
        {
          id: 3002,
          subject: "New User Registration",
          message: "Lisa Thompson from R&D department has requested an account.",
          read: false,
          createdAt: new Date().getTime() - 2 * 24 * 3600000, // 2 days ago
          type: "USER_REGISTRATION"
        },
        {
          id: 3003,
          subject: "Password Reset Request",
          message: "User 'james.wilson' has requested a password reset.",
          read: true,
          createdAt: new Date().getTime() - 4 * 24 * 3600000, // 4 days ago
          type: "PASSWORD_RESET"
        }
      ];

    default:
      return [];
  }
};

// Helper function to format date for display
export const formatNotificationDate = (timestamp) => {
  const now = new Date();
  let date;
  
  // Handle array format from backend [year, month, day, hour, minute, second, millisecond]
  if (Array.isArray(timestamp)) {
    const [year, month, day, hour, minute, second, millisecond] = timestamp;
    date = new Date(year, month - 1, day, hour || 0, minute || 0, second || 0, Math.min(millisecond || 0, 999));
  } else {
    date = new Date(timestamp);
  }
  
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffDay > 0) {
    return diffDay === 1 ? '1 day ago' : `${diffDay} days ago`;
  } else if (diffHour > 0) {
    return diffHour === 1 ? '1 hour ago' : `${diffHour} hours ago`;
  } else if (diffMin > 0) {
    return diffMin === 1 ? '1 minute ago' : `${diffMin} minutes ago`;
  } else {
    return 'Just now';
  }
};
